<!--
//================================================================================
// ID:BC055
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC055
//
// <<Modification History>>
// Version  | Date       | Updated By         | Content
// ---------+------------+--------------------+-----------------------------------
// 01.02.00 | 2022/10/05 | 富士通Japan株式会社 | 新規作成
// 01.03.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />
		<h2 class="contents__h2">検索条件</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title bosyu-title">
							募集の種類
						</th>
						<td class="padding__bottom-10">
							<div class="margin__left-20 contents__input--label">
								{{ form.bosyuKindNm }}
							</div>
							<div class="bosyu-message">
								<caution-message
									:classDiv="'font-size'"
									:tyuibunItems="disp.bosyuTyui1Items"
								/>
							</div>
							<div class="bosyu-message">
								<caution-message
									:classDiv="'font-size'"
									:tyuibunItems="disp.bosyuTyui2Items"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title bosyu-title">
							住宅の種別
						</th>
						<td class="padding__bottom-10">
							<div class="margin__left-20">
								<list-box
									class="contents__input--select width-jyutaku"
									:modelValue="form.jyutakuKind"
									:name="'住宅の種別'"
									:groupId="'jyutakuKindInfo'"
									:listItems="disp.jyutakuKindList"
									:reducedDisplayFlg="true"
									@update:modelValue="changeJyutakuList"
									ref="jyutakuKind"
									tabindex="1"
									/>
								<itemerror-message :groupId="'jyutakuKindInfo'"/>
							</div>
							<div class="contents__caution--div margin__left-20 padding__bottom-m7">
								<div class="line__height-20">
									<caution-message
										:classDiv="'font-size'"
										:cdHanyo1="'T0009'"
										:cdHanyo2="disp.jyutakuKind"
									/>
								</div>
							</div>
							<div v-if="form.jyutakuKind == '22'" class="contents__caution--div margin__left-20 padding__bottom-m7 margin__top-m5">
								<div class="line__height-20">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.jyutakuTyui2"
									/>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title nyukyo-title">
							都営住宅に入居する人数<span class="contents__hissu">必須</span>
						</th>
						<td class="padding__bottom-10 background__color--white">
							<div class="margin__left-20">
								<number-input
									class="width-nyukyo"
									:modelValue="form.nyukyoNinzu"
									:maxLength="2"
									:name="'入居予定人数'"
									:groupId="'nyukyoNinzuInfo'"
									:requireFlg="true"
									:numberType="NUMBERINPUT_TYPE.INTEGER"
									@update:modelValue="inputNyukyoNinzu"
									ref="nyukyoNinzu"
									tabindex="2"
								/>人
								<itemerror-message :groupId="'nyukyoNinzuInfo'"/>
							</div>
							<div class="contents__caution contents__caution--multiple">
								<div class="margin__left-20">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.ninzuTyui1Items"
									/>
								</div>
								<div class="margin__left-20">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.ninzuTyui2Items"
									/>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<h2 class="contents__h2">検索条件の追加</h2>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="width-kushicho-title">
						<th class="contents__input--title margin__bottom-m25">区市町</th>
						<td>
							<div class="margin__left-20">
								<label class="contents__caution">※区市町を選択してください。</label>
							</div>
							<div class="margin__left-20">
								<label class="contents__caution">※複数選択が可能です。</label>
							</div>
							<div class="margin__left-20">
									<label class="contents__caution">※選択できない区市町は、入力された「住宅の種別」及び「都営住宅に入居する人数」に合致する募集住宅のない区市町です。</label>
							</div>
							<div id="kubuLayer" class="width-kubu-title">
								<label class="padding__left-3per font-size-16">区部</label>
							</div>
							<div v-if="disp.kubuMsgFlg == true">
								<div class="margin__left-20">
									<label class="contents__caution">申込み可能な住宅はありません</label>
								</div>
							</div>
							<div class="content">
								<div class="cond__checkbox margin__left-20">
									<check-box
										:classDiv="'width-kubu'"
										:modelValue="form.kubu"
										:cdType="'L0013'"
										:cdHanyo1="'1'"
										:name="'区部'"
										:enabledItems="disp.kubuList"
										:groupId="'kubuInfo'"
										:classItem="'width-kushibu-range'"
										@update:modelValue="form.kubu = $event"
										ref="kubu"
										tabindex="3" />
									<itemerror-message :groupId="'kubuInfo'"/>
								</div>
							</div>
							<div id="shibuLayer" class="width-shibu-title margin__top-5">
								<label class="padding__left-3per font-size-16">市部</label>
							</div>
							<div v-if="disp.shibuMsgFlg == true">
								<div class="margin__left-20">
									<label class="contents__caution">申込み可能な住宅はありません</label>
								</div>
							</div>
							<div class="cond__checkbox margin__left-20">
								<check-box
									:classDiv="'width-shibu'"
									:modelValue="form.shibu"
									:cdType="'L0013'"
									:cdHanyo1="'2'"
									:name="'市部'"
									:enabledItems="disp.shibuList"
									:groupId="'shibuInfo'"
									:classItem="'width-kushibu-range'"
									@update:modelValue="form.shibu = $event"
									ref="shibu"
									tabindex="26" />
								<itemerror-message :groupId="'shibuInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="width-jyutakuname-title background__color--light-gray">
						<th class="contents__input--title margin__bottom-m18">住宅名</th>
						<td>
							<div class="jyutakuname-title margin__left-20">
								<text-input
									class="width-jyutakuname"
									:modelValue="form.jyutakuName"
									:maxLength="30"
									:name="'住宅名'"
									:groupId="'jyutakuNameInfo'"
									:placeholder="'（フリーワード）'"
									@update:modelValue="form.jyutakuName = $event"
									ref="jyutakuName"
									tabindex="52" />
								<itemerror-message :groupId="'jyutakuNameInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title width-trans-title">主な交通機関</th>
						<td class="border__bottom-none">
							<div class="width-trans-item">
								<text-input
									class="contents__input--text width-trans1"
									:modelValue="form.trans1"
									:maxLength="70"
									:name="'主な交通機関１'"
									:groupId="'transInfo'"
									:placeholder="'（フリーワード）'"
									@update:modelValue="form.trans1 = $event"
									ref="trans1"
									tabindex="53" />
								<text-input
									class="contents__input--text width-trans2"
									:modelValue="form.trans2"
									:maxLength="70"
									:name="'主な交通機関２'"
									:groupId="'transInfo'"
									:placeholder="'（フリーワード）'"
									@update:modelValue="form.trans2 = $event"
									ref="trans2"
									tabindex="54" />
								<text-input
									class="contents__input--text width-trans3"
									:modelValue="form.trans3"
									:maxLength="70"
									:name="'主な交通機関３'"
									:groupId="'transInfo'"
									:placeholder="'（フリーワード）'"
									@update:modelValue="form.trans3 = $event"
									ref="trans3"
									tabindex="55" />
								<itemerror-message :groupId="'transInfo'"/>
							</div>
							<div class="width-trans-tyui">
								<label class="contents__caution">※路線、駅、バス停等を入力してください。</label>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title"></th>
						<td class="margin__top-m20">
							<div class="width-keyword">
								<radio-button
									:modelValue="form.keyword"
									:listItems="disp.keywordList"
									:name="'キーワードを含む'"
									:radioGroupName="'keyword'"
									:cdKbn="CD_HANDLE_TYPE.ID_CD"
									:disabledFlg="false"
									@update:modelValue="form.keyword = $event"
									ref="keyword"
									tabindex="56"
								/>
							</div>
							<div class="width-tohomin-title">駅・バス停からの徒歩分&nbsp;
								<list-box
									class="contents__input--select width-tohomin"
									:modelValue="form.tohoMin"
									:name="'徒歩時間'"
									:groupId="'tohoMinInfo'"
									:cdType="'L0033'"
									@update:modelValue="form.tohoMin = $event"
									ref="tohoMin"
									tabindex="57" />
								<itemerror-message :groupId="'tohoMinInfo'"/>
							</div>
							<div class="cond__checkbox width-busJyogai-title">
								<check-box
									:modelValue="form.busJyogai"
									:name="'バス利用除外'"
									:groupId="'busJyogaiInfo'"
									:listItems="disp.busJyogaiList"
									@update:modelValue="form.busJyogai = $event"
									ref="busJyogai"
									tabindex="58" />
								<itemerror-message :groupId="'busJyogaiInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="background__color--light-gray">
						<th class="contents__input--title margin__bottom-m18">間取り</th>
						<td>
							<div class="cond__checkbox width-madori-item">
								<check-box
									:classDiv="'width-madori'"
									:modelValue="form.madori"
									:cdType="'L0020'"
									:name="'間取り'"
									:groupId="'madoriInfo'"
									:classItem="'width-madori-range'"
									@update:modelValue="form.madori = $event"
									ref="madori"
									tabindex="59" />
								<itemerror-message :groupId="'madoriInfo'"/>
							</div>
							<div class="width-madori-tyui">
								<label class="contents__caution">※複数選択が可能です。</label>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title width-senyoarea-title">専用面積(m&sup2;)</th>
						<td>
							<div class="width-senyoarea-item">
								<list-box
									class="contents__input--select width-senyoarea"
									:modelValue="form.senyoAreaFrom"
									:name="'専用面積（From）'"
									:groupId="'senyoAreaInfo'"
									:cdType="'L0047'"
									:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
									:blankFlg="false"
									@update:modelValue="form.senyoAreaFrom = $event"
									ref="senyoAreaFrom"
									tabindex="71" />
								m&sup2;&nbsp;～
								<list-box
									class="contents__input--select width-senyoarea"
									:modelValue="form.senyoAreaTo"
									:name="'専用面積（To）'"
									:groupId="'senyoAreaInfo'"
									:cdType="'L0051'"
									:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
									:blankFlg="false"
									@update:modelValue="form.senyoAreaTo = $event"
									ref="senyoAreaTo"
									tabindex="72" />
								m&sup2;&nbsp;
								<itemerror-message :groupId="'senyoAreaInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="background__color--light-gray">
						<th class="contents__input--title margin__bottom-m18">建設年度からの<br/>経過年数</th>
						<td>
							<div class="margin__left-20">
								<list-box
									class="contents__input--select width-buildyears"
									:modelValue="form.buidYears"
									:name="'建設年度からの経過年数'"
									:groupId="'buidYearsInfo'"
									:cdType="'L0014'"
									:cdKbn="CD_HANDLE_TYPE.MIX_HANYO21"
									@update:modelValue="form.buidYears = $event"
									ref="buidYears"
									tabindex="73" />
								<itemerror-message :groupId="'buidYearsInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title elevator-title">エレベーター</th>
						<td>
							<div class="cond__checkbox margin__left-20">
								<check-box
									:classDiv="'width-elevator'"
									:modelValue="form.elevator"
									:name="'エレベーター'"
									:groupId="'elevatorInfo'"
									:listItems="disp.elevatorList"
									@update:modelValue="form.elevator = $event"
									ref="elevator"
									tabindex="74" />
								<itemerror-message :groupId="'elevatorInfo'"/>
							</div>
							<div class="contents__caution--div">
								<div class="contents__caution--div width-elevaotr-tyui">
									<div>
										<p class="contents__caution contents__caution--multiple">
											<caution-message
												:classDiv="'font-size'"
												:tyuibunItems="disp.elevatorTyuiItems"
											/>
										</p>
									</div>
								</div>
							</div>
						</td>
					</tr>
					<tr class="background__color--white background__color--light-gray">
						<th class="contents__input--title barrierfree-title">バリアフリー</th>
						<td>
							<div class="cond__checkbox width-barrierfree-item">
								<check-box
									:classDiv="'width-barrierFree'"
									:modelValue="form.barrierFree"
									:name="'バリアフリー'"
									:groupId="'barrierFreeInfo'"
									:listItems="disp.barrierFreeList"
									@update:modelValue="form.barrierFree = $event"
									ref="barrierFree"
									tabindex="75"
								/>
								<itemerror-message :groupId="'barrierFreeInfo'"/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div class="search-button">
				<input type="submit" value="検索" class="contents__btn--normal" tabindex="76" @click="clickSearchBtn" :disabled="disp.searchBtnDisabledFlg">
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import RadioButton from '@/components/RadioButton.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_isOperation } from '@/common/browserUtility.js';
import { co_isEmpty, co_checkHalfNumber } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTop, co_toTrans } from '@/common/screenUtility.js';

import { NUMBERINPUT_TYPE, CD_HANDLE_TYPE, DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC055_INIT, PATH_BC055_GET_KUSHIBU, PATH_BC055_COUNT } from '@/const/route.js';
import { STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_ERROR_SETMSG, STORE_DATA_ADD_DATA, STORE_DATA_GETDATA, STORE_ENV_GET_LIST_MAX_COUNT,
			STORE_VIEW_PROGRESS, STORE_ERROR_SET_INPUT_ERR, STORE_VIEW_CLEAR_PAGE } from '@/const/store.js';

export default {
	name: "BC055",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'radio-button': RadioButton,
		'caution-message' : CautionMessage,
		'itemerror-message': ItemErrorMessage
	},
	data: function () {
		return {
			form: {
				bosyuKind: '254',					 // 募集の種類
				bosyuKindNm: '随時募集（先着順）',	  // 募集の種類名
				jyutakuKind: '',					// 住宅の種別
				nyukyoNinzu: '',					// 入居人数
				jyutakuName: '',					// 住宅名
				kubu: '',							// 区部
				shibu: '',							// 市部
				kushicyoList: [],					// 区市町リスト
				trans1: '',							// 主な交通機関１
				trans2: '',							// 主な交通機関２
				trans3: '',							// 主な交通機関３
				transList: [],						// 主な交通機関リスト
				keyword: '1',						// キーワードを含む
				tohoMin: '',						// 徒歩時間
				busJyogai: '',						// バス利用の住戸を除く
				madori: '',							// 間取り
				madoriList: [],						// 間取りリスト
				senyoAreaFrom: '',					// 専用面積（From）
				senyoAreaTo: '',					// 専用面積（To）
				buidYears: '',						// 建設年度からの経過年数
				buidYearsFrom: '',					// 建設年度（From）
				buidYearsTo: '',					// 建設年度（To）
				buildYearsCd: '',					// 建設年度からの経過年数コード
				elevator: '',						// エレベーター
				barrierFree: '',					// バリアフリー
				hanyoCode: '',						// 汎用コード
				zikoUmu: '',						// 居室内で病死等があった住宅の有無
			},
			disp: {
				jyutakuDataCount: 0,			// 募集住宅情報対象件数
				jyutakuDataList: [],			// 住宅の種別マスタデータリスト
				jyutakuKindList: [],			// 住宅の種別リスト
				bosyuTyui1Items: ['C0003'],		// 募集の種類注意文リスト１
				bosyuTyui2Items: ['C0205'],	    // 募集の種類注意文リスト２
				ninzuTyui1Items: ['C0011'],		// 入居予定人数注意文１リスト
				ninzuTyui2Items: ['C0206'],		// 入居予定人数注意文2リスト
				jyutakuTyui2: [],				// 住宅の種別注意文２
				keywordList: [],				// キーワードを含むリスト
				busJyogaiList: [],				// バス利用除外
				elevatorList: [],				// エレベーターリスト
				elevatorTyuiItems: ['C0033'],	// エレベーター注意文リスト
				barrierFreeList: [],			// バリアフリーリスト
				wsize: 0,						// ウインドウサイズ
				jyutakuKind: '',				// 住宅の種別
				bosyuKindDisabledFlg: false,	// 募集の種類活性・非活性フラグ
				searchBtnDisabledFlg: false,	// 検索ボタン活性・非活性フラグ
				kubuList: [],					// 区部リスト
				shibuList: [],					// 市部リスト
				kubuMsgFlg: false,				// 区部メッセージフラグ
				shibuMsgFlg: false,				// 市部メッセージフラグ
			},
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE
		}
	},
	created: async function() {

		// ブラウザチェック
		if(!await co_isOperation()) {
			co_toTrans('BrowserError');
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 住宅の種別初期情報取得
		let initData = await co_post(PATH_BC055_INIT);
		this.disp.jyutakuDataCount = initData.bosyuKensu;
		this.disp.jyutakuDataList = initData.jyutakuDataList;

		if (this.disp.jyutakuDataCount == 0) {
			co_errorDialog(co_getMessage('E0058'), this.callBack);
		}

		// 前回の検索条件確認
		let data = this.$store.getters[STORE_DATA_GETDATA]('BC055');
		let disp = this.$store.getters[STORE_DATA_GETDATA]('BC055DISP');
		let code = this.form.bosyuKind.substring(2);
		let list = this.disp.jyutakuDataList.filter(x => x.kbBosyuKbn == code);
		let jyutakuKindList = new Array();
		for (let i = 0; i < list.length; i++) {
			jyutakuKindList.push({ idCd: list[i].kbZyutaku, nmCd: list[i].nmZyutaku });
		}
		this.disp.jyutakuKindList = jyutakuKindList;

		if (data != null) {
			// 検索条件設定
			this.form = data;

			// 区市部絞り込み
			this.searchKushibu();

		}else{
			// 専用面積初期値設定
			this.form.senyoAreaFrom = '0';
			this.form.senyoAreaTo = '99';
		}

		if (disp != null) {
			// 住宅の種別注意文設定
			this.disp.jyutakuKind = disp.jyutakuKind;
		}

		let bc058Data = this.$store.getters[STORE_DATA_GETDATA]('BC058');
		if (bc058Data != null) {
			// 世帯情報入力からの遷移の場合

			if (bc058Data.cdStatus != null && bc058Data.cdStatus == '2' ) {
				// 受付済みの場合、募集の種類を非活性にする。
				this.disp.bosyuKindDisabledFlg = true;
			}

			if (this.form.bosyuKind == '') {
				this.form.bosyuKind = bc058Data.kbBosyu;
				this.form.jyutakuKind = bc058Data.kbZyutaku;
				this.changeJyutakuList(this.form.jyutakuKind);
				this.form.nyukyoNinzu = bc058Data.nuNyukyo;
			}
		}


		// 住宅の種別初期値設定
		this.changeJyutakuList(this.form.jyutakuKind);

		// キーワード項目設定
		this.disp.keywordList = [
			{ idCd: '1', nmCd: 'いずれかのキーワードを含む'},
			{ idCd: '2', nmCd: 'すべてのキーワードを含む'}
		];
		// バス利用除外項目設定
		this.disp.busJyogaiList = [
			{ idCd: '1', nmCd: 'バス利用の住戸を除く'}
		];
		// エレベーター項目設定
		this.disp.elevatorList = [
			{ idCd: '1', nmCd: '有り'}
		];
		// バリアフリー項目設定
		this.disp.barrierFreeList = [
			{ idCd: '1', nmCd: 'バリアフリー仕様の住宅のみ表示'}
		];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.jyutakuKind.focus();
		
		// ページトップへ遷移
		co_toTop();
	},
	methods: {

		// コールバック関数
		callBack: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ページトップへ遷移
				co_toTop();

				return;
			}
		},
		
		// 住宅の種別リスト作成
		makeJyutakuList: function() {

			let jyutakuList = new Array();
			for (let i = 0; i < this.disp.jyutakuDataList.length; i++) {
				jyutakuList.push({ idCd: this.disp.jyutakuDataList[i].kbZyutaku, nmCd: this.disp.jyutakuDataList[i].nmZyutaku });
			}
			return jyutakuList;
		},

		// 住宅の種別リスト変更
		changeJyutakuList: async function (val) {

			this.form.jyutakuKind = val;
			this.disp.jyutakuKind = this.form.jyutakuKind;

			// 住宅の種別注意文２設定
			let jyutakuTyui2 = new Array();
			if (this.form.jyutakuKind == '22') {
				// 住宅の種別が随時募集の「世帯向（一般募集住宅）※２人以上の家族向のみ」である場合
				jyutakuTyui2.push('C0251');
			}
			this.disp.jyutakuTyui2 = jyutakuTyui2;

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 入居予定人数入力
		inputNyukyoNinzu: function (val) {
			this.form.nyukyoNinzu = val;

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 区部・市部絞り込み
		searchKushibu: async function () {

			// 募集の種類、住宅の種別、入居人数がそれぞれ入力されている場合
			if (!co_isEmpty(this.form.jyutakuKind)
				&& !co_isEmpty(this.form.nyukyoNinzu)
				&& co_checkHalfNumber(this.form.nyukyoNinzu)) {

				let params = {
					'bosyuKind' : this.form.bosyuKind,
					'jyutakuKind' : this.form.jyutakuKind,
					'nyukyoNinzu' : this.form.nyukyoNinzu
				};
				let data = await co_post(PATH_BC055_GET_KUSHIBU, params);
				
				let kubuList = this.form.kubu.split(',');
				let selectKubuList = [];

				this.disp.kubuList = new Array();
				let kubu = data.kushibuList.filter(x => x.cdHanyo1 == '1');
				for (let i = 0; i < kubu.length; i++) {
					this.disp.kubuList.push(kubu[i].idCd);
					if (kubuList.indexOf(kubu[i].idCd) >= 0) {
						selectKubuList.push(kubu[i].idCd);
					}
				}

				// 区部の値を初期化する
				this.form.kubu = '';

				// 対象の区部が取得できなかった場合
				if (this.disp.kubuList.length == 0){
					this.disp.kubuList =[''];
					this.disp.kubuMsgFlg = true;
				} else {
					if ( selectKubuList.length > 0 ) {
						this.form.kubu = selectKubuList.join(',');
					} 
					this.disp.kubuMsgFlg = false;
				}

				let shibuList = this.form.shibu.split(',');
				let selectShibuList = [];

				this.disp.shibuList = new Array();
				let shibu = data.kushibuList.filter(x => x.cdHanyo1 == '2');
				for (let i = 0; i < shibu.length; i++) {
					this.disp.shibuList.push(shibu[i].idCd);
					if (shibuList.indexOf(shibu[i].idCd) >= 0) {
						selectShibuList.push(shibu[i].idCd);
					}
				}

				// 市部の値を初期化する
				this.form.shibu = '';

				// 対象の市部が取得できなかった場合
				if (this.disp.shibuList.length == 0){
					this.disp.shibuList = [''];
					this.disp.shibuMsgFlg = true;
				} else {
					if ( selectShibuList.length > 0 ) {
						this.form.shibu = selectShibuList.join(',');
					} 
					this.disp.shibuMsgFlg = false;
				}
			}
		},

		// 検索ボタン押下
		clickSearchBtn: async function () {

			// 検索ボタン非活性
			this.disp.searchBtnDisabledFlg = true;

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);
			// 単項目チェック
			this.$refs.nyukyoNinzu.validate();

			// アコーディオンを開く
			await this.$nextTick();

			this.$refs.kubu.validate();
			this.$refs.shibu.validate();
			this.$refs.jyutakuName.validate();
			this.$refs.trans1.validate();
			this.$refs.trans2.validate();
			this.$refs.trans3.validate();
			this.$refs.keyword.validate();
			this.$refs.tohoMin.validate();
			this.$refs.busJyogai.validate();
			this.$refs.madori.validate();
			this.$refs.senyoAreaFrom.validate();
			this.$refs.senyoAreaTo.validate();
			this.$refs.buidYears.validate();
			this.$refs.elevator.validate();
			this.$refs.barrierFree.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// 検索ボタン活性
				this.disp.searchBtnDisabledFlg = false;
				return;
			}

			let inputError = false;

			// 専用面積大小チェック
			if (!co_isEmpty(this.form.senyoAreaFrom) && !co_isEmpty(this.form.senyoAreaTo)) {
				
				if (Number(this.form.senyoAreaFrom) > Number(this.form.senyoAreaTo)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'senyoAreaInfo', msg: co_getMessage("E0012")});
					this.$refs.senyoAreaFrom.setError();
					this.$refs.senyoAreaTo.setError();
					if (!inputError) this.$refs.senyoAreaFrom.focus();
					inputError = true;
				}
			}

			// 入居予定人数チェック
			if (!co_isEmpty(this.form.nyukyoNinzu)) {

				if(this.form.nyukyoNinzu < 2 || this.form.nyukyoNinzu > 20) {
					// エラーメッセージ：E0063を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0063', '入居予定人数', '2人', '20人')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				} else {
					this.checkNyukyoNinzu();
				}
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				if (!co_isEmpty(this.form.buidYears)) {
					let date = new Date();
					this.form.buildYearsCd = this.form.buidYears.substring(0,1);
					let year = this.form.buidYears.substring(1);

					if (this.form.buildYearsCd == '0') {
						// 建設年度.汎用コード２が'0'の場合
						this.form.buidYearsTo = date.getFullYear();
					} else {
						// 上記以外の場合
						this.form.buidYearsTo = date.getFullYear() - year;
					}
					this.form.buidYearsFrom = date.getFullYear() - year;
				}

				// 区市町コード設定
				let kushicyoCd = '';
				if (!co_isEmpty(this.form.kubu)) {
					if (!co_isEmpty(this.form.shibu)) {
						kushicyoCd = this.form.kubu + ',' + this.form.shibu;
					} else {
						kushicyoCd = this.form.kubu;
					}
				} else if(!co_isEmpty(this.form.shibu))	{
					kushicyoCd = this.form.shibu;
				}
				this.form.kushicyoList = new Array();

				if (!co_isEmpty(kushicyoCd)) {
					this.form.kushicyoList = kushicyoCd.split(',');
				}

				// 間取り項目設定
				this.form.madoriList = new Array();
				if (!co_isEmpty(this.form.madori)) {
					this.form.madoriList = this.form.madori.split(',');
				}

				// 主な交通機関項目設定
				this.form.transList = new Array();
				if (!co_isEmpty(this.form.trans1)) {
					this.form.transList.push(this.form.trans1);
				}
				if (!co_isEmpty(this.form.trans2)) {
					this.form.transList.push(this.form.trans2);
				}
				if (!co_isEmpty(this.form.trans3)) {
					this.form.transList.push(this.form.trans3);
				}

				// 検索処理実行
				this.doSearch();
			}

			// 検索ボタン活性
			this.disp.searchBtnDisabledFlg = false;
		},

		// 入居予定人数チェック 
		checkNyukyoNinzu: function () {

			let inputError = false;

			// 入居人数が「2人未満」の場合
			if (this.form.nyukyoNinzu < 2) {
				this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0060')});
				this.$refs.nyukyoNinzu.setError();
				if (!inputError) this.$refs.nyukyoNinzu.focus();
				inputError = true;
			}
		},

		// 検索実行
		doSearch: async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let data =	await co_post(PATH_BC055_COUNT, this.form);
			let maxCount = this.$store.getters[STORE_ENV_GET_LIST_MAX_COUNT];

			// 取得件数が0件の場合
			if (data.listCount == null || data.listCount == 0) {
				// エラーメッセージ：E0014を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0014'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				return;

			// 取得件数が最大件数を超えた場合
			} else if (data.listCount > maxCount)	{
				// エラーメッセージ：E0013を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0013', maxCount));
				
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				return;
			}

			// 募集住宅一覧画面に渡すパラメータ取得
			this.form.hanyoCode = this.form.bosyuKind.substring(2);
			if (!co_isEmpty(this.form.jyutakuKind)) {
				let list = this.disp.jyutakuDataList.filter(x => x.kbBosyuKbn == this.form.hanyoCode && x.kbZyutaku == this.form.jyutakuKind);
				this.form.zikoUmu = list[0].kbZiko;
			}

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC055', data: this.form });
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC055DISP', data: this.disp });

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// ページング情報クリア
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);

			// 募集住宅一覧画面（管理者用）に遷移
			let param = {'paramData' : this.form};
			co_toTrans('BC056', param);

		}
	}
};
</script>

<style scoped>

@media screen and (min-width: 768px) {

	.contents__hissu {
		right: 1%;
	}

	.width-jyutaku {
		width: auto;
		max-width: 100%;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}

	/* 入居予定人数 */
	.nyukyo-title {
		background-color: #fdfdfd;
	}
	.width-nyukyo {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 3%;
		text-align: right;
		margin-right: 7px;
	}

	/* 住宅名 */
	.width-jyutakuname-title {
		margin: 10px 20px;
		background-color: #f1f2f5;
	}
	.jyutakuname-title {
		margin-left: 20px !important;
	}
	.width-jyutakuname {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 50%;
	}

	/* 区市町 */
	.width-kushicho-title {
		background-color: #fdfdfd !important;
		border-top: 1px dashed #aaa;
	}
	.width-kubu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-bottom: 5px;
		margin-left: 15px;
	}
	.width-shibu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-left: 15px;
	}
	.width-kubu{
		font-size: 16px;
	}
	.width-shibu{
		font-size: 16px;
	}

	/* 主な交通機関 */
	.width-trans-title {
		border-bottom: none !important;
	}
	.width-trans-item {
		margin-left: 20px;
	}
	.width-trans1 {
		width: 30%;
	}
	.width-trans2 {
		width: 30%;
		margin-left: 8px;
	}
	.width-trans3 {
		width: 30%;
		margin-left: 8px;
	}
	.width-trans-tyui {
		margin-left: 20px;
	}

	/* 徒歩時間 */
	.width-tohomin-title {
		margin-top: 10px;
		margin-left: 20px;
	}
	.width-tohomin {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		margin-left: 5px;
	}
	/* キーワード */
	.width-keyword {
		margin-top: -18px;
		margin-bottom: -10px;
		margin-left: 20px;
	}
	/* バス利用除外 */
	.width-busJyogai-title {
		font-size: 16px;
		margin-left: 5px;
	}

	/* 間取り */
	.width-madori-item {
		margin-left: 20px;
	}
	.width-madori {
		font-size: 16px;
	}
	.width-madori-tyui {
		margin-left: 20px;
	}

	/* 専用面積 */
	.width-senyoarea-title {
		font-size: 16px;
	}
	.width-senyoarea-item {
		margin-left: 20px;
	}
	.width-senyoarea {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}
	.width-buildyears {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}

	/* エレベーター */
	.width-elevator {
		font-size: 16px;
		margin-left: -18px;
	}
	.width-elevaotr-tyui {
		margin-left: 16px;
	}

	/* バリアフリー */
	.width-barrierfree-item {
		margin-left: 0px;
	}
	.width-barrierfree {
		font-size: 16px;
		margin-left: -18px;
	}

	/* 検索ボタン */
	.search-button {
		text-align: center;
	}

	/* 募集の種類注意文 */
	.bosyu-message {
		margin-left: 20px;
		margin-bottom: -3px;
	}

	/* フォントサイズ */
	.font-size {
		font-size: 16px !important;
	}

}
</style>